export const SCHEDULE_DATA = {
  emptySchedule: {
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  },
  daysOfTheWeek: [
    {
      day: "Mon",
      shortDay: "Mon",
      longDay: "Monday",
      value: "Monday",
      index: 1,
    },
    {
      day: "Tue",
      shortDay: "Tue",
      longDay: "Tuesday",
      value: "Tuesday",
      index: 2,
    },
    {
      day: "Wed",
      shortDay: "Wed",
      longDay: "Wednesday",
      value: "Wednesday",
      index: 3,
    },
    {
      day: "Thu",
      shortDay: "Thu",
      longDay: "Thursday",
      value: "Thursday",
      index: 4,
    },
    {
      day: "Fri",
      shortDay: "Fri",
      longDay: "Friday",
      value: "Friday",
      index: 5,
    },
    {
      day: "Sat",
      shortDay: "Sat",
      longDay: "Saturday",
      value: "Saturday",
      index: 6,
    },
    {
      day: "Sun",
      shortDay: "Sun",
      longDay: "Sunday",
      value: "Sunday",
      index: 0,
    },
  ],
  monthsOfTheYear: [
    { longName: "January", shortName: "Jan" },
    { longName: "February", shortName: "Feb" },
    { longName: "March", shortName: "Mar" },
    { longName: "April", shortName: "Apr" },
    { longName: "May", shortName: "May" },
    { longName: "June", shortName: "Jun" },
    { longName: "July", shortName: "Jul" },
    { longName: "August", shortName: "Aug" },
    { longName: "September", shortName: "Sep" },
    { longName: "October", shortName: "Oct" },
    { longName: "November", shortName: "Nov" },
    { longName: "December", shortName: "Dec" },
  ],
  timeOfDay: [
    {
      label: "Before 12pm",
      value: "Morning",
    },
    {
      label: "12 - 5pm",
      value: "Afternoon",
    },
    {
      label: "After 5pm",
      value: "Evening",
    },
  ],
  timeRange: [
    {
      range: "Morning",
      description: "6 - 9am",
      times: [6, 7, 8, 9],
      icon: "dawn",
    },
    {
      range: "Late morning",
      description: "9 - 12pm",
      times: [9, 10, 11, 12],
      icon: "morning",
    },
    {
      range: "Afternoon",
      description: "12 - 3pm",
      times: [12, 13, 14, 15],
      icon: "afternoon",
    },
    {
      range: "Late afternoon",
      description: "3 - 6pm",
      icon: "sunset",
      times: [15, 16, 17, 18],
    },
    {
      range: "Evening",
      description: "6 - 9pm",
      times: [18, 19, 20, 21],
      icon: "evening",
    },
    {
      range: "Late evening",
      description: "9 - 12am",
      icon: "late-evening",
      times: [21, 22, 23, 24],
    },
    {
      range: "Night",
      description: "0 - 3am",
      times: [0, 1, 2, 3],
      icon: "night-time",
    },
    {
      range: "Late night",
      description: "3 - 6am",
      icon: "sunrise",
      times: [3, 4, 5, 6],
    },
  ],
  mapPeriodToTime: {
    Morning: ["6:00 AM", "6:30 AM", "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM"],
    "Late morning": [
      "9:00 AM",
      "9.30 AM",
      "10:00 AM",
      "10:30 AM",
      "11:00 AM",
      "11:30 AM",
    ],
    Afternoon: [
      "12:00 PM",
      "12:30 PM",
      "1:00 PM",
      "1:30 PM",
      "2:00 PM",
      "2:30 PM",
    ],
    "Late afternoon": [
      "3:00 PM",
      "3:30 PM",
      "4:00 PM",
      "4:30 PM",
      "5:00 PM",
      "5:30 PM",
    ],
    Evening: ["6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM"],
    "Late evening": [
      "9:00 PM",
      "9:30 PM",
      "10:00 PM",
      "10:30 PM",
      "11:00 PM",
      "11:30 PM",
    ],
    Night: [
      "00:00 AM",
      "00:30 AM",
      "01:00 AM",
      "01:30 AM",
      "02:00 AM",
      "02:30 AM",
    ],
    "Late night": [
      "03:00 AM",
      "03:30 AM",
      "04:00 AM",
      "04:30 AM",
      "05:00 AM",
      "05:30 AM",
    ],
  },
  hourlyTimes: [
    "6:00 AM",
    "6:30 AM",
    "7:00 AM",
    "7:30 AM",
    "8:00 AM",
    "8:30 AM",
    "9:00 AM",
    "9.30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "1:00 PM",
    "1:30 PM",
    "2:00 PM",
    "2:30 PM",
    "3:00 PM",
    "3:30 PM",
    "4:00 PM",
    "4:30 PM",
    "5:00 PM",
    "5:30 PM",
    "6:00 PM",
    "6:30 PM",
    "7:00 PM",
    "7:30 PM",
    "8:00 PM",
    "8:30 PM",
    "9:00 PM",
    "9:30 PM",
    "10:00 PM",
  ],
  durationOfLesson: [
    {
      label: "1 week",
      value: 1,
    },
    {
      label: "2 weeks",
      value: 2,
    },
    {
      label: "3 weeks",
      value: 3,
    },
    {
      label: "Monthly",
      value: 4,
    },
  ],
  hoursOfLesson: [
    {
      label: "1 hour",
      value: 1,
    },
    { label: "1.5 hours", value: 1.5 },
    {
      label: "2 hours",
      value: 2,
    },
    {
      label: "2.5 hours",
      value: 2.5,
    },
    {
      label: "3 hours",
      value: 3,
    },
    {
      label: "4 hours",
      value: 4,
    },
    {
      label: "5 hours",
      value: 5,
    },
    {
      label: "6 hours",
      value: 6,
    },
  ],
  lessonUrgency: [
    {
      label: "Immediately",
      value: "Immediately",
    },
    {
      label: "In a few days",
      value: "In a few days",
    },
    {
      label: "In a few weeks",
      value: "In a few weeks",
    },
    {
      label: "Not yet sure",
      value: "At an agreed date",
    },
  ],
  lessonsPerWeek: [
    { value: 1, label: "1 day/wk" },
    { value: 2, label: "2 days/wk" },
    { value: 3, label: "3 days/wk" },
    { value: 4, label: "4 days/wk" },
    { value: 5, label: "5 days/wk" },
    { value: 6, label: "6 days/wk" },
    { value: 7, label: "7 days/wk" },
  ],
};

export const learningNeeds = (isMaleChild: boolean) => [
  {
    title: `I feel ${isMaleChild ? "he" : "she"} is falling behind`,
    value: "Falling behind",
    description: `${
      isMaleChild ? "He" : "She"
    }'s struggling with comprehension and needs help with fundamentals`,
  },
  {
    title: "Motivation to improve",
    value: "Needs motivation",
    description: `I want to keep ${
      isMaleChild ? "him" : "her"
    } on track as I feel ${
      isMaleChild ? "he" : "she"
    }'s alright but needs some push`,
  },
  {
    title: "Extend their learning",
    value: "Extend learning",
    description: `${
      isMaleChild ? "He" : "She"
    } needs to be further challenged to learn more and gain mastery`,
  },
];
